import { AxnAdminSessionsState } from "@idw-types/state/axn-admin-sessions-state";
import { AxnAdminSessionsActionTypes, AxnAdminSessionsActions } from "../actions/axn-admin-sessions-actions";

export const initialAxnAdminSessionsState: AxnAdminSessionsState = {
    axnAdminSessions: {
        isLoading: false,
        axnAdminSessions: null
    }
};

export const axnAdminSessionsReducer = (
    state: AxnAdminSessionsState = initialAxnAdminSessionsState,
    action: AxnAdminSessionsActions
): AxnAdminSessionsState => {
    switch (action.type) {
        case AxnAdminSessionsActionTypes.SET_AXN_ADMIN_SESSIONS_LOADING:
            return {
                ...state,
                axnAdminSessions: {
                    ...(action.payload.isLoading
                        ? { ...initialAxnAdminSessionsState.axnAdminSessions }
                        : { ...state.axnAdminSessions }),
                    isLoading: action.payload.isLoading
                }
            };
        case AxnAdminSessionsActionTypes.SET_AXN_ADMIN_SESSIONS:
            return {
                ...state,
                axnAdminSessions: {
                    ...state.axnAdminSessions,
                    axnAdminSessions: action.payload.axnAdminSessions,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};